import React from "react";
import { loaderContainer } from "../styles";

const Loader: React.FC = () => {
  return <div css={loaderContainer}>Lädt ...</div>;
};

export default Loader;
